;(function($){
  var fetchCitiesList = {
    init: function(){
    	if(!window.citiesList){
        $.ajax({
          method: 'GET',
          url: '/mobile/resource/v2/local_cities.json',
          contentType: "application/json",
          dataType: "json",
          success: function(data){
            data = _.isString(data)? JSON.parse(data) : data;
            window.citiesList = data;
            if (window.CT && window.CT.app == 'local') {
              window.currentCityName = window.currentCityName || (window.App && window.App.router && window.App.router.currentView && window.App.router.currentView.model) ? window.App.router.currentView.model.get('jsons').cityname : '';
            } else {
              window.currentCityName = window.currentCityName || '';
            }
            window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
            
            if(window.wlCitiesList && window.wl_enable_all_cities == false){
            	//filter the cities
            	var newCityList = [];
            	for (country in window.citiesList.country){
            		//window.citiesList.country[country].topcities = window.wlCitiesList;
            		window.citiesList.country[country].topcities = _.map(window.wlCitiesList,function(city){return city.city_name})
            	}
            }
            
          },
          error: function(data){
            console.log(data);
          }
        });
      }
    },
    getCityProductConfig: function(cityName, callback){
      var city= cityName.toLowerCase();
      $.ajax({
        method: 'GET',
        url: '/local/api/v1/ctLocalAutoComp?city=' + city,
        contentType: "application/json",
        dataType: "json",
        success: function(data){
          data = _.isString(data)? JSON.parse(data) : data;
          console.log(data);
          if(data[city]){
            callback(city, data[city]);
          }
        },
        error: function(err){
          console.log(err);
        }
      });
    },
    switchCity: function(cityName){
      if(parent.window.isHomePage){
        fetchCitiesList.getCityProductConfig(cityName, function(city, cityConfig){
          city = city.toLowerCase();
          if(cityConfig.homepage){
            pathName = "/local/"+city+"/featured-activities-in-"+city
          }else if(cityConfig.ttd){
            pathName = "/local/"+city+"/things-to-do-in-"+city
          }else if(cityConfig.fnb){
            pathName = "/local/"+city+"/food-and-drinks-in-"+city
          }else if(cityConfig.events){
            pathName = "/local/"+city+"/events-in-"+city
          }
          if (CT && CT.utils && CT.utils.cookies){
            CT.utils.cookies.create('localCurrentCity', city, 365);
          }
          window.location = pathName; 
        });  
      }else{
        if (CT && CT.app && CT.app == 'local') {
          if (App && App.router && App.router.currentView && App.router.currentView.model) {
            var pathName = App.router.currentView.model.get('jsons').productConfig.pathName;
            if (CT && CT.utils && CT.utils.cookies){
              CT.utils.cookies.create('localCurrentCity', cityName, 365);
            }
            var newPathName = cityName ? ('local/' + cityName.toLowerCase() + '/' + pathName + '-' + cityName.toLowerCase()) : window.location.href;
            if (window.currentCityName != cityName) {
              App.router.redirectTo(newPathName, {pushState: false});
            }
          }
        } else {
          window.currentCityName = cityName.toLowerCase();
          window.currentCityCode = window.currentCityName.replace(/\s/g,"_");
          if (CT && CT.utils && CT.utils.cookies){
            CT.utils.cookies.create('localCurrentCity', window.currentCityName, 365);
          }
          if (window.localsHome) {
            localsHome.init(true);
          }
        }
      } 
    }
  }
  window.fetchCitiesList = fetchCitiesList;
  window.fetchCitiesList.init();
})(jQuery);

